import { LoadingButton } from '@mui/lab';
import { Tooltip, Typography } from '@mui/material';
import { Stack } from '@mui/system';

interface HeaderSectionProps {
  fullScreen: boolean;
  onSubmit: () => void;
  loading?: boolean;
  isFormValid: boolean;
  missingFieldsMessage: string;
}

export default function HeaderSection({
  fullScreen,
  onSubmit,
  loading = false,
  isFormValid,
  missingFieldsMessage,
}: HeaderSectionProps) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        px: 3,
        py: 2,
        width: '100%',
        ...(!fullScreen && {
          position: 'sticky',
          top: 0,
          zIndex: 100,
          backdropFilter: 'blur(10px)',
          backgroundColor: 'rgba(18, 18, 18, 0.7)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
        }),
      }}
    >
      <Typography variant="h6" sx={{ color: 'white', fontWeight: 500 }}>
        Rate your experience ✨
      </Typography>

      {!fullScreen && (
        <Tooltip title={!isFormValid ? missingFieldsMessage : ''} arrow placement="bottom">
          <span>
            {' '}
            {/* Wrapper needed for disabled buttons with tooltips */}
            <LoadingButton
              variant="contained"
              color="primary"
              loading={loading}
              onClick={onSubmit}
              disabled={loading || !isFormValid}
            >
              Submit
            </LoadingButton>
          </span>
        </Tooltip>
      )}
    </Stack>
  );
}
